import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const NAVY = "#205393";

const SessionBanner: React.FC = () => {
  const { providerName, startDate, endDate, receiptDate, fileName } = useSelector(
    (s: RootState) => s.commissionStatement
  );

  if (!providerName) return null;

  const formatDate = (iso: string) => {
    if (!iso) return "—";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  };

  const Divider = () => (
    <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.2)", flexShrink: 0 }} />
  );

  const Field = ({ label, value }: { label: string; value: string }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <span style={{ fontSize: "10px", fontWeight: 600, color: "rgba(255,255,255,0.55)", textTransform: "uppercase", letterSpacing: "0.6px" }}>
        {label}
      </span>
      <span style={{ fontSize: "14px", fontWeight: 600, color: "#fff" }}>{value}</span>
    </div>
  );

  return (
    <div style={{ padding: "8px 0px", background: "#fff", borderBottom: "1px solid #e2e5ea" }}>
      <div style={{
        background: NAVY,
        borderRadius: "5px",
        padding: "10px 18px",
        display: "flex",
        alignItems: "center",
        gap: "24px",
        flexWrap: "wrap",
      }}>
        <Field label="Provider" value={providerName} />
        <Divider />
        <Field label="Date Range" value={`${formatDate(startDate)} – ${formatDate(endDate)}`} />
        <Divider />
        <Field label="Receipt Date" value={formatDate(receiptDate)} />
        {fileName && (
          <>
            <Divider />
            <Field label="File" value={fileName} />
          </>
        )}
      </div>
    </div>
  );
};

export default SessionBanner;
